import { render, staticRenderFns } from "./EduLabelButton.vue?vue&type=template&id=34f92f8c&scoped=true"
import script from "./EduLabelButton.vue?vue&type=script&lang=js"
export * from "./EduLabelButton.vue?vue&type=script&lang=js"
import style0 from "./EduLabelButton.vue?vue&type=style&index=0&id=34f92f8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f92f8c",
  null
  
)

export default component.exports